const RolesEnum = {
    Expert: "სპეციალისტი",
    HeadOfAgency: "სააგენტოს უფროსი",
    HeadOfDepartment: "სამმართველოს უფროსი",
    DeputyHeadOfAgency: "უფროსის მოადგილე",
    user: "მომხმარებელი",

}
export default RolesEnum